import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { UploadComponent } from './components/upload/upload';
import { DataStoreService } from './services/data-store';
import { AuthService, User } from './services/auth';

// Note: Routing is now provided in main.ts using provideRouter

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    UploadComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, AfterViewInit {
  hasData = false;
  currentUser: User | null = null;

  constructor(
    private dataStore: DataStoreService,
    public authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.dataStore.data$.subscribe(data => {
      this.hasData = !!data;
    });
    
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
      
      // Handle initial routing based on authentication status
      if (!user && this.router.url === '/') {
        this.router.navigate(['/login']);
      } else if (user && this.router.url === '/login') {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  ngAfterViewInit() {
    // Set initial theme based on system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (prefersDark) {
      document.body.classList.add('dark-theme');
    }
  }

  // Method to handle theme toggle - called from template
  toggleTheme() {
    const isDark = document.body.classList.toggle('dark-theme');
    const themeIcon = document.getElementById('theme-toggle-icon');
    if (themeIcon) {
      themeIcon.textContent = isDark ? '☀️' : '🌙';
    }
  }
}
